import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';

// sub-sections
import ProfileAccount from './components/ProfileAccount';
import ProfileNotifications from './components/ProfileNotifications';
import ProfileSubscription from './components/ProfileSubscription';
import ProfileSecurity from './components/ProfileSecurity';
import AccountIcon from '../../icons/AccountIcon';
import CrownIcon from '../../icons/CrownIcon';
import BellIcon from '../../icons/BellIcon';
import ShieldIcon from '../../icons/ShieldIcon';

const Profile = () => {
    const [activeSection, setActiveSection] = useState('account');

    return (
        <div className="pageProfile">

            <nav className="workbenchProfileSidebar" aria-label={__('Profile navigation', 'soundbetween')}>
                <ul>
                    <li>
                        <button
                            type="button"
                            onClick={() => setActiveSection('account')}
                            aria-current={activeSection === 'account' ? 'page' : undefined}
                        >
                            <AccountIcon/>
                            {__('Account', 'soundbetween')}
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            onClick={() => setActiveSection('subscription')}
                            aria-current={activeSection === 'subscription' ? 'page' : undefined}
                        >
                            <CrownIcon/>
                            {__('Il tuo piano', 'soundbetween')}
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            onClick={() => setActiveSection('notifications')}
                            aria-current={activeSection === 'notifications' ? 'page' : undefined}
                        >
                            <BellIcon/>
                            {__('Preferenze notifiche', 'soundbetween')}
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            onClick={() => setActiveSection('security')}
                            aria-current={activeSection === 'security' ? 'page' : undefined}
                        >
                            <ShieldIcon/>
                            {__('Sicurezza & Privacy', 'soundbetween')}
                        </button>
                    </li>
                </ul>
            </nav>

            {activeSection === 'account' && <ProfileAccount setActiveSection={setActiveSection} />}
            {activeSection === 'subscription' && <ProfileSubscription />}
            {activeSection === 'notifications' && <ProfileNotifications />}
            {activeSection === 'security' && <ProfileSecurity />}

        </div>
    );
};

export default Profile;
